import { RouterLocationState, useTabContext } from "@/components/layout/tab-context";

export const useTabLocationState = <T extends RouterLocationState = RouterLocationState>() => {
  const { routerLocationState } = useTabContext();
  return routerLocationState as T;
};
